import { IResponseData } from '@/models/common';
import { AxiosResponse } from 'axios';

function getApiResponse<T>(resp: AxiosResponse<IResponseData<T>>) {
  if (resp === undefined || resp === null) {
    throw 'fetch failed';
  }

  const {
    data: { ResultCode, ResultData, Exception },
  } = resp;
  if (ResultCode == 0) return ResultData;
  throw { ResultCode, Exception, ResultData } as IResponseData<T>;
}

export default getApiResponse;
